import withAemIntegration from "../../withAemIntegration";

const HeroEditConfig = {
  emptyLabel: "Hero - Content Fragment",

  isEmpty: function (props) {
    return (
      !props || !props.fragmentPath || props.fragmentPath.trim().length < 1
    );
  },
};

const Hero = () => <div>Not Implemented</div>;

export default withAemIntegration("lexus/components/hero-content-fragment")(
  Hero,
  HeroEditConfig
);
